module.exports = __webpack_public_path__ + "static/media/super_pack_FR_128x128.4e07dc4a.png";